module.exports = __webpack_public_path__ + "static/media/icon_d.9843ee25.svg";